import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { EvrideoCommonModule } from "app/js/src/components/common/evrideo-common.module";

import { DestinationSettingsPanelComponent } from "./destination-settings-panel.component";
import { DestinationYoutubeSettingsComponent } from "./destination-youtube-settings.component";
import { DestinationPlatformSettingsComponent } from "./destination-platform-settings.component";

@NgModule({
  imports: [CommonModule, FormsModule, MatCheckboxModule, EvrideoCommonModule],
  declarations: [
    DestinationSettingsPanelComponent,
    DestinationYoutubeSettingsComponent,
    DestinationPlatformSettingsComponent,
  ],
  exports: [
    DestinationSettingsPanelComponent,
    DestinationYoutubeSettingsComponent,
    DestinationPlatformSettingsComponent,
  ],
})
export class DestinationSettingsModule {}

